import React from 'react';
import { TAG_SYNERGIES } from '../game/depth';

// v3.4: Combo/Synergy HUD — shows current tag counts + which synergies have fired this turn.
// TAG_SYNERGIES entries: { tag, count, name, effect }. When count met, synergy fires (state.synergiesFiredTurn[tag] = true).
export default function ComboHUD({ state }) {
  if (!state) return null;
  const counts = state.tagCountsTurn || {};
  const fired = state.synergiesFiredTurn || {};

  // Only show tags with either count > 0 or a synergy definition
  const rows = Object.entries(TAG_SYNERGIES).map(([tag, syn]) => ({
    tag,
    have: counts[tag] || 0,
    need: syn.count,
    label: syn.name,
    effect: syn.effect,
    fired: !!fired[tag],
  }));
  // Sort: fired first, then highest progress
  rows.sort((a, b) => (b.fired ? 1 : 0) - (a.fired ? 1 : 0) || (b.have / b.need) - (a.have / a.need));
  // Show top 3 most relevant (either fired or have progress) + defaults
  const relevant = rows.filter(r => r.have > 0 || r.fired);
  if (relevant.length === 0) return null;

  const TAG_COLOR = {
    rizz: '#ff007f', mog: '#39ff14', ratio: '#00e5ff',
    copium: '#c084fc', schizo: '#ffd700', doom: '#ff2b2b',
  };

  return (
    <div
      className="brutal-border-dim bg-[#050505] px-2 py-1.5 flex flex-col gap-1"
      data-testid="combo-hud"
      style={{ borderColor: 'var(--pink)', boxShadow: '2px 2px 0 var(--pink)' }}
    >
      <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)] font-mono">COMBOS · TURN {state.turn || 1}</div>
      {relevant.slice(0, 4).map(r => {
        const color = TAG_COLOR[r.tag] || '#888';
        const pct = Math.min(100, Math.floor((r.have / r.need) * 100));
        return (
          <div key={r.tag} className="flex items-center gap-2 text-[10px] font-mono uppercase" data-testid={`combo-${r.tag}`}>
            <span className="w-14" style={{ color }}>{r.tag.toUpperCase()}</span>
            <div className="flex-1 h-2 bg-[#0f0f0f] relative overflow-hidden">
              <div
                className="h-full transition-all duration-200"
                style={{ width: `${pct}%`, background: r.fired ? color : `${color}88` }}
                data-testid={`combo-bar-${r.tag}`}
              />
            </div>
            <span className={r.fired ? 'font-black' : ''} style={{ color: r.fired ? color : '#888' }}>
              {r.have}/{r.need}
            </span>
            {r.fired && <span style={{ color }} className="text-[9px]" data-testid={`combo-fired-${r.tag}`}>✓ FIRED</span>}
          </div>
        );
      })}
    </div>
  );
}
